<div class="titleBox"> <h1 style="text-align: center">Contacts</h1></div>
<div><hr></div>
<br>
<br>
<button class="buttonAddNew" mat-raised-button (click)="addContactDialog()">New <fa-icon [icon]="fauserplus"></fa-icon></button>
      <ngx-table [configuration] = "configuration"  [data]="contacts$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate" (event)="onEvent($event)">
          <ng-template let-row>
            <td>
              <div>
                  <button button mat-raised-button color="green" (click)="openDialog(row)">
                    <fa-icon [icon]="faedit"></fa-icon>
                  </button>
              </div>

              <div>
                  <button mat-button color="warn" (click)="deleteContactDialog(row)">
                    <fa-icon [icon]="fatrash"></fa-icon>
                  </button>
              </div>
            </td>

            <td>
              <div>
                {{row.name}}
              </div>
            </td>

            <td>
                <div>
                  {{row.phone}}
                </div>
            </td>

            <td>
                <div>
                  {{row.email}}
                </div>
            </td>

            <td>
              <div>
                {{row.customer_name}}
              </div>
          </td>



          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>
